<template>
  <div class="header__form search overflow-hidden shrink-0">
    <div
      data-grid
      class="search__wrapper grid--va-center h-100"
    >
      <div
        data-grid
        class="search__icon grid--center"
        @click="$emit('search-icon-clicked', true)"
      >
        <SearchIcon />
      </div>

      <div class="search__input flex-1">
        <input
          type="text"
          class="w-100"
          :placeholder="placeholder"
          @input="$emit('update:modelValue', $event.target.value)"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import SearchIcon from '../icons/SearchIcon'

export default defineComponent({
  name: 'SearchInput',

  components: {
    SearchIcon
  },

  props: {
    placeholder: {
      type: String,
      required: true
    },

    modalValue: {
      type: String,
      default: () => ''
    }
  },

  emits: [
    'update:modelValue',
    'search-icon-clicked'
  ]
})
</script>

<style lang="scss" scoped>
  aside {
    .search {
      border: solid 1px transparent;
    }

    &:not(.closed-aside) .search {
      border-color: rgb(var(--gray9));
    }

    &.closed-aside {
      .search {
        max-width: 100%;
      }

      .search__wrapper {
        padding: 0;
        max-width: 240px;
      }

      .search__icon {
        flex: 0 0 34px;
      }

      .search__input {
        opacity: 0;
        visibility: hidden;
      }
    }
  }

  .search {
    width: 292px;
    border-radius: 10px;
    background: var(--white-background-theme);

    &,
    &__wrapper {
      transition: all .4s ease-in-out;
    }

    &__wrapper {
      height: 100%;
      padding: 0 12px;
    }

    &__icon {
      cursor: pointer;

      line-height: 1;
      color: var(--primary);
      width: 25px;
      height: 25px;
      flex: 0 0 25px;

      svg {
        width: 25px;
        margin: 0 auto;
      }
    }

    &__input {
      transition: .4s ease-in-out;

      input {
        margin-inline: 10px 0;

        border: 0 none;
        outline: 0 none;
        background-color: transparent;

        color: rgb(var(--gray1));
        font: 400 1.2rem / 1.3125rem "Nunito", sans-serif;
      }
    }
  }
</style>
